import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { OrdersBaseComponent } from "@mypxplat/xplat/features";
import { BaseComponent, StorageService, UserService, OrderService, ProductService, FenderShopifyOrder } from "@mypxplat/xplat/core";
import { Router } from "@angular/router";
import { AppService } from "@mypxplat/xplat/web/core";
import { EditAddressComponent } from "../modals";

@Component({
  selector: "myp-shared-orders",
  templateUrl: "orders.component.html",
  standalone: false,
})
export class OrdersComponent extends OrdersBaseComponent implements OnInit, OnDestroy {
  public destroy$: Subject<any> = new Subject();
  public orders: Array<any>;
  public fenderOrders: Array<FenderShopifyOrder>;
  public recurringPayments: Array<any>;
  public loading: boolean = true;
  public displayedSection: string = "orders";
  public orderMetadata: any = {};
  public addresses: Array<any>;
  public editingAddresses: any = {};
  public giftCards: Array<any>;
  constructor(
    storageService: StorageService,
    userService: UserService,
    public orderService: OrderService,
    public productService: ProductService,
    private _router: Router,
    public appService: AppService
  ) {
    super(userService);
  }

  ngOnInit() {
    window.scrollTo(0, 0);

    this.orderService.getOrders().subscribe((result: any[]) => {
      this.orders = result.filter((order) => order.type != "recurring");
      this.recurringPayments = result.filter((order) => order.type == "recurring");
      this.loading = false;
    });
    this.orderService.getFenderShopifyAccountDetails(this.userService.user.email, true).subscribe((result: any) => {
      let defaultAddressId = this.orderService.fenderUserShopData?.defaultAddress?.id;
      this.addresses = this.orderService.fenderUserShopData?.addresses;
      if (this.addresses?.length && defaultAddressId) {
        this.addresses.forEach((address) => {
          if (address.id == defaultAddressId) address.default = true;
        });
      }
      if (result?.shopifyId) {
        setTimeout(() => {
          this.orderService.getFenderShopifyOrders(result.shopifyId, result.storeId).subscribe((orders: any) => {
            orders.forEach((order) => {
              this.orderMetadata[order.id] = [
                { title: "Ordered", value: new Date(order.createdAt).toLocaleDateString() },
                { title: "Total", value: order.totalPrice.amount + " " + order.totalPrice.currency },
              ];
              if (order.fulfillments.length) {
                this.orderMetadata[order.id].push({ title: "Status", value: "Shipped" });
              }
            });
            this.fenderOrders = orders;
            setTimeout(() => {
              this.orderService.getFenderGiftCards(result.shopifyId, result.storeId).subscribe((giftCards: any) => {
                this.giftCards = giftCards;
              });
            }, 100);
          });
        }, 100);
      }
    });
  }

  switchSection(section, force?) {
    this.displayedSection = section;
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  deleteAddress(address: any) {
    if (confirm("Are you sure you would like to remove this address? This cannot be undone.")) {
      this.editingAddresses[address.id] = true;
      let addressId = address.id.split("MailingAddress/")[1].split("?model_name=CustomerAddress")[0];
      this.orderService.deleteShopifyAddress(this.orderService.fenderUserShopData.shopifyId, addressId).subscribe((result: any) => {
        this.addresses = this.orderService.fenderUserShopData?.addresses;
        let defaultAddressId = this.orderService.fenderUserShopData?.defaultAddress?.id;
        if (this.addresses?.length) {
          this.addresses.forEach((address) => {
            if (address.id == defaultAddressId) address.default = true;
          });
        }
        this.editingAddresses[address.id] = false;
      });
    }
  }
  editAddress(address: any) {
    const modalRef = this.appService.showModal(EditAddressComponent, { size: "sm" });
    let transformedAddress = {
      city: address.city,
      countryCode: address.countryCode,
      id: address.id,
      address_phone: address.phone,
      state: address.provinceCode,
      street: address.address1,
      street2: address.address2,
      zipcode: address.zip,
    };
    modalRef.componentInstance.address = transformedAddress;
    modalRef.componentInstance.fenderShopifyAddress = true;
    modalRef.componentInstance.addressAdded.subscribe((result) => {
      if (result) {
        // find the ID in a string that looks like this: gid://shopify/MailingAddress/11046665912615?model_name=CustomerAddress
        this.editingAddresses[address.id] = true;
        let addressId = result.id.split("MailingAddress/")[1].split("?model_name=CustomerAddress")[0];
        this.orderService
          .addUpdateShopifyAddress(
            this.orderService.fenderUserShopData.shopifyId,
            {
              address1: result.street,
              address2: result.street2,
              city: result.city,
              company: "",
              provinceCode: result.state,
              countryCode: result.countryCode,
              firstName: this.userService.user.firstName,
              lastName: this.userService.user.lastName,
              phone: result.address_phone,
              zip: result.zipcode,
            },
            addressId
          )
          .subscribe((result) => {
            this.addresses = this.orderService.fenderUserShopData?.addresses;
            let defaultAddressId = this.orderService.fenderUserShopData?.defaultAddress?.id;
            if (this.addresses?.length) {
              this.addresses.forEach((address) => {
                if (address.id == defaultAddressId) address.default = true;
              });
            }
            this.editingAddresses[address.id] = false;
          });

        // heres where we actually save the address. coming soon.
      }
    });
  }

  addAddress() {
    const modalRef = this.appService.showModal(EditAddressComponent, { size: "sm" });
    modalRef.componentInstance.address = {};
    modalRef.componentInstance.fenderShopifyAddress = true;
    modalRef.componentInstance.addressAdded.subscribe((result) => {
      if (result) {
        this.orderService
          .addUpdateShopifyAddress(this.orderService.fenderUserShopData.shopifyId, {
            address1: result.street,
            address2: result.street2,
            city: result.city,
            company: "",
            provinceCode: result.state,
            countryCode: result.countryCode,
            firstName: this.userService.user.firstName,
            lastName: this.userService.user.lastName,
            phone: result.address_phone,
            zip: result.zipcode,
          })
          .subscribe((result) => {
            this.addresses = this.orderService.fenderUserShopData?.addresses;
            let defaultAddressId = this.orderService.fenderUserShopData?.defaultAddress?.id;
            if (this.addresses?.length && defaultAddressId) {
              this.addresses.forEach((address) => {
                if (address.id == defaultAddressId) address.default = true;
              });
            }
          });

        // heres where we actually save the address. coming soon.
      }
    });
  }

  goShopping() {
    window.open("https://presonus.com");
  }

  goToProduct(id) {
    this._router.navigate(["/products/detail", id]);
  }
}
